//
// Return an Image or Video player from Airtable field
//
import React from 'react';
import moment from 'moment';

import ChevronMotif from '../components/ChevronMotif';

// Methods extracted "as-is" from the original checkout screen
export const toAUD = (cents?: number, allowZero?: boolean) =>
  cents
    ? (cents / 100).toLocaleString('en-AU', {
        style: 'currency',
        currency: 'AUD',
      })
    : allowZero
    ? '$0.00'
    : '$--';

export const toAUDAbs = (cents: number, allowZero: boolean) =>
  cents
    ? Math.abs(cents / 100).toLocaleString('en-AU', {
        style: 'currency',
        currency: 'AUD',
      })
    : allowZero
    ? '$0.00'
    : '$--';

export const renderSticker = (item: any, isProductScreen?: boolean) => (
  <ChevronMotif key={item.id} item={item} isProductScreen={isProductScreen} />
);

export const renderStickerSmall = (item: any) => (
  <ChevronMotif key={item.id} item={item} small />
);

export const formatDate = (
  dateString: moment.MomentInput,
  format = 'YYYY-MM-DD',
) => moment(dateString, format).format('DD/MM/YYYY');

export const chunkIntoN = (arr: any[], n: number) => {
  const size = Math.ceil(arr.length / n);
  return Array.from({length: n}, (_, i) =>
    arr.slice(i * size, i * size + size),
  );
};

// https://stackoverflow.com/a/8495740/1084192
export const arrayChunks = <T,>(array: T[], chunkSize: number) => {
  const chunks: T[][] = [];
  let chunkIndex = 0;
  for (let i = 0; i < array.length; i += chunkSize) {
    const chunk = array.slice(i, i + chunkSize);
    chunks[chunkIndex++] = chunk;
  }
  return chunks;
};

export const sum = (a: number, b: number) => a + b;

export const centsToDollarsString = (cents: number) => (cents / 100).toFixed(2);
